import { ConfirmationFormValues } from '../types';

export const initialValues: ConfirmationFormValues = { code: '' };
